const { Card, CardContent } = require('@andes/card');
const { TextField } = require('@andes/textfield');
const { useI18n } = require('nordic/i18n');

const translate = require('../../../translation');
const { Field } = require('../Components/Form/Field');

const { useFormAddress } = require('./useFormAddress');

const buildNameHelpMessage = ({ hasError, value, translations }) => {
  if (hasError) {
    if (value?.length) {
      const isInComplete = value
        .trim()
        .split(/\s+/)
        .reduce((isValid, value) => isValid && value.length > 1, true);

      return isInComplete
        ? translations.SHIPPING_ERROR_INCOMPLETE_NAME
        : translations.SHIPPING_ERROR_INVALID_NAME;
    }

    return translations.REQUIRED_FORM_FIELD;
  }

  return undefined;
};

const buildPhoneHelpMessage = ({ hasError, value, translations }) => {
  if (hasError) {
    return value?.length
      ? translations.SHIPPING_ERROR_INVALID_PHONE
      : translations.REQUIRED_FORM_FIELD;
  }

  return undefined;
};

const buildEmailHelpMessage = ({ hasError, value, translations }) => {
  if (hasError) {
    return value?.length
      ? translations.SHIPPING_ERROR_VALID_EMAIL
      : translations.REQUIRED_FORM_FIELD;
  }

  return undefined;
};

const AddressFormContact = ({ paddingAndesCard, formFields, hasEmail }) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);
  const { isMobile } = useFormAddress();

  return (
    <Card
      paddingSize={paddingAndesCard}
      shadow={isMobile && 'elevated'}
      className="mb-32"
    >
      <CardContent className="d-flex d-flex-column g-32">
        <Field name="name">
          {({ value, field, error }) => (
            <TextField
              label={translations.FIRST_AND_LAST_NAME}
              srLabel={translations.FIRST_AND_LAST_NAME}
              value={value}
              modifier={error && 'error'}
              helper={buildNameHelpMessage({
                hasError: error,
                value,
                translations,
              })}
              placeholder={translations.SHIPPING_NAME_EX}
              {...{ ...formFields.name, ...field }}
            />
          )}
        </Field>

        <Field name="phoneNumber">
          {({ value, field, error }) => (
            <TextField
              label={translations.CONTACT_PHONE_NUMBER}
              srLabel={translations.CONTACT_PHONE_NUMBER}
              value={value}
              modifier={error && 'error'}
              helper={buildPhoneHelpMessage({
                hasError: error,
                value,
                translations,
              })}
              placeholder={translations.SHIPPING_PHONE_EX}
              {...{ ...formFields.phoneNumber, ...field }}
            />
          )}
        </Field>

        {hasEmail && (
          <Field name="email">
            {({ value, field, error }) => (
              <TextField
                value={value}
                label={translations.EMAIL}
                srLabel={translations.EMAIL}
                modifier={error && 'error'}
                helper={buildEmailHelpMessage({
                  hasError: error,
                  value,
                  translations,
                })}
                placeholder={translations.SHIPPING_EMAIL_EX}
                {...{ ...formFields.email, ...field }}
              />
            )}
          </Field>
        )}
      </CardContent>
    </Card>
  );
};

module.exports = { AddressFormContact };
